<template>
  <div class="">
    <div class="">
      <div class="d-flex justify-content-between">
        <div class="bg-tabs my-2">Related Product</div>
      </div>
      <InputText
        v-model="filter.search"
        textFloat=""
        placeholder="Search Article no, Barcode, Name"
        type="text"
        name="search_customer"
        faIcon="search"
        :disabled="isBusy"
        className="mb-2  overflow-auto w-50"
        @onEnter="handleSearch"
        @onClickIcon="handleSearch"
      />
      <b-table
        responsive
        striped
        hover
        :fields="fields"
        :items="items"
        :busy="isBusy"
        show-empty
        empty-text="No matching records found"
        class="table-main"
      >
        <template v-slot:cell(image_url)="{ item }">
          <img :src="item.image_url" class="img-size" v-if="item.image_url" />
          <img
            v-else
            src="@/assets/images/noimg.png"
            alt="no-image-product"
            class="img-size"
          />
        </template>
        <template v-slot:cell(action)="{ item }">
          <b-button
            :disabled="subFilter.product_id == item.id"
            @click="selectProduct(item)"
            >เลือก</b-button
          >
        </template>
        <template v-slot:cell(name)="{ item }">
          <div
            class="text-link"
            @click="$router.push(`/product/detail/${item.id}`)"
          >
            {{ item.name }}
          </div>
          <span class="text-gray">{{ item.barcode }}</span>
        </template>
        <template v-slot:cell(price)="{ item }">
          {{ item.price | numeral("0,0.00") }}
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
      </b-table>
      <Pagination
        @handleChangeTake="handleChangeTake"
        :pageOptions="pageOptions"
        :filter="filter"
        :rows="rows"
        @pagination="pagination"
      />

      <b-table
        responsive
        striped
        hover
        :fields="subFields"
        :items="subItem"
        :busy="isSubBusy"
        show-empty
        empty-text="No matching records found"
        class="table-main mt-3"
        :sort-by.sync="subFilter.sortBy"
        :sort-desc.sync="subFilter.sortDesc"
        no-local-sorting
        @sort-changed="storeSorting"
      >
        <template v-slot:cell(plant_id)="{ item }">
          {{ item.plant_id || "-" }}
        </template>
        <template v-slot:cell(branch_group)="{ item }">
          {{ item.branch_group || "-" }}
        </template>
        <template v-slot:cell(price)="{ item }">
          {{ item.price | numeral("0,0.00") }}
        </template>
        <template v-slot:cell(status)="{ item }">
          <div
            :class="{
              'text-success': item.status,
              'text-danger': !item.status,
            }"
          >
            {{ item.status ? "เปิดใช้งาน" : "ไม่เปิดใช้งาน" }}
          </div>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
      </b-table>
      <Pagination
        @handleChangeTake="handleChangeTakeSubItem"
        :pageOptions="pageOptions"
        :filter="subFilter"
        :rows="subRows"
        @pagination="paginationSubItem"
      />
    </div>
  </div>
</template>
<script>
import OtherLoading from "@/components/loading/OtherLoading";
import { mapGetters } from "vuex";
export default {
  components: {
    OtherLoading,
  },
  computed: {
    ...mapGetters({
      branchId: "getBranchId",
    }),
  },
  name: "Product",
  data() {
    return {
      tebIndex: 0,
      isLoading: false,
      filter: {
        search: "",
        page: 1,
        take: 10,
        product_id: this.$route.params.id,
      },
      items: [],
      isBusy: false,
      rows: 0,
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      fields: [
        {
          key: "action",
          label: "",
          thClass: "w-1",
        },
        {
          key: "article_no",
          label: "Product Code ",

          thClass: "w-1",
        },

        {
          key: "name",
          label: "Name",
          thClass: "w-1",
        },
        {
          key: "price",
          label: "Price",

          thClass: "w-1",
        },
      ],
      isFetch: false,
      subItem: [],
      subFields: [
        {
          key: "plant_id",
          label: "Plant Id",
          thClass: "w-1",
        },
        {
          key: "branch_group",
          label: "Branch Group",
          thClass: "w-1",
        },

        {
          key: "branch_name",
          label: "Branch Name",
          thClass: "w-1",
        },
        {
          key: "stock_type_name",
          label: "Stock",
          thClass: "w-1",
        },

        {
          key: "status",
          label: "Active",
          thClass: "w-1",
        },
      ],
      subFilter: {
        search: "",
        page: 1,
        take: 10,
        product_id: null,
        branch_id: null,
        sortBy: "",
        sortDesc: false,
        SortColumnId: 0,
        SortType: true,
      },

      isSubBusy: false,
      subRows: 0,
      is_serial: false,
    };
  },
  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      if (this.isFetch) {
        return;
      }
      this.isBusy = true;

      const res = await this.axios.post(
        `${this.$baseUrl}/product/get_product_related_list`,
        this.filter
      );
      if (res.result == 1) {
        this.isFetch = true;

        this.items = res.detail.productRelatedResponse_List;

        this.rows = res.detail.total_count;
      }

      this.isBusy = false;
    },
    async handleSearch() {
      this.filter.page = 1;
      this.isFetch = false;
      await this.getList();
    },
    pagination(page) {
      this.filter.page = page;
      this.isFetch = false;
      this.getList();
    },
    handleChangeTake(value) {
      this.subFilter.page = 1;
      this.subFilter.take = value;

      this.getList();
    },
    async paginationSubItem(page) {
      this.subFilter.page = page;

      if (!this.is_serial) {
        await this.getSubItem();
      } else {
        await this.getSubItemSerial();
      }
    },
    async handleChangeTakeSubItem(value) {
      this.subFilter.page = 1;
      this.subFilter.take = value;
      if (!this.is_serial) {
        await this.getSubItem();
      } else {
        await this.getSubItemSerial();
      }
    },
    async selectProduct(item) {
      this.subFilter.product_id = item.id;
      this.subFilter.branch_id = this.branchId;
      if (!item.is_serial) {
        this.subFields = [
          {
            key: "plant_id",
            label: "Plant Id",
            thClass: "w-1",
          },
          {
            key: "branch_group",
            label: "Branch Group",
            thClass: "w-1",
            sortable: true,
          },

          {
            key: "branch_name",
            label: "Branch Name",
            thClass: "w-1",
            sortable: true,
          },
          {
            key: "stock_type_name",
            label: "Stock",
            thClass: "w-1",
            sortable: true,
          },
          {
            key: "custom_1",
            label: "",
            thClass: "w-1",
          },
          {
            key: "custom_2",
            label: "",
            thClass: "w-1",
          },
          {
            key: "custom_3",
            label: "",
            thClass: "w-1",
          },
          {
            key: "quantity",
            label: "Quantity",
            thClass: "w-1",
            sortable: true,
          },
          {
            key: "status",
            label: "Active",
            thClass: "w-1",
          },
        ];

        this.is_serial = false;
        await this.getSubItem();
      } else {
        this.subFields = [
          {
            key: "serial",
            label: "Serial",
            thClass: "w-1",
          },
          // {
          //   key: "plant_id",
          //   label: "Plant Id",
          //   thClass: "w-1",
          // },
          {
            key: "branch_group",
            label: "Branch Group",
            thClass: "w-1",
            sortable: true,
          },

          {
            key: "branch_name",
            label: "Branch Name",
            thClass: "w-1",
            sortable: true,
          },
          {
            key: "stock_type_name",
            label: "Stock",
            thClass: "w-1",
            sortable: true,
          },
          {
            key: "custom_1",
            label: "",
            thClass: "w-1",
          },
          {
            key: "custom_2",
            label: "",
            thClass: "w-1",
          },
          {
            key: "custom_3",
            label: "",
            thClass: "w-1",
          },

          { key: "price", label: "Price", thClass: "w-1", sortable: true },
        ];
        this.is_serial = true;
        await this.getSubItemSerial();
      }
    },
    async getSubItem() {
      this.isSubBusy = true;
      const res = await this.axios.post(
        `${this.$baseUrl}/product/get_related_product_stock`,
        this.subFilter
      );

      if (res.detail.variants.length) {
        this.options = res.detail.variants;

     let variant = await this.$store.dispatch(
            "transformVariantData",
            res.detail.variants
          );
        for (const element of res.detail.related_product_stock) {
          for (const opt of element.options) {
            let key = variant.find((e) => e.id == opt.id);

            element[key.key] = opt.name;
          }
        }
        let i = 4;

        for (const element of res.detail.variants) {
          this.subFields[i].label = element.attribute.name;
          this.subFields[i].key = element.attribute.name;
          i++;
        }
      }
      this.subItem = res.detail.related_product_stock;
      this.subRows = res.detail.count;
      this.subFields = this.subFields.filter((el) => el.label);
      this.isSubBusy = false;
    },

    async getSubItemSerial() {
      this.isSubBusy = true;
      const res = await this.axios.post(
        `${this.$baseUrl}/product/get_related_product_serial_stock/${this.subFilter.product_id}`,
        this.subFilter
      );
      if (res.detail.variants.length) {
        this.options = res.detail.variants;

       let variant = await this.$store.dispatch(
            "transformVariantData",
            res.detail.variants
          );
        for (const element of res.detail.related_product_stock) {
          for (const opt of element.options) {
            let key = variant.find((e) => e.id == opt.id);

            element[key.key] = opt.name;
          }
        }
        let i = 4;

        for (const element of res.detail.variants) {
          this.subFields[i].label = element.attribute.name;
          this.subFields[i].key = element.attribute.name;
          i++;
        }
      }
      this.subItem = res.detail.related_product_stock;
      this.subRows = res.detail.count;
      this.subFields = this.subFields.filter((el) => el.label);
      this.isSubBusy = false;
    },
    storeSorting(ctx) {
      const sameColumn = this.subFilter.sortBy === ctx.sortBy;
      const sameDirection = this.subFilter.sortDesc === ctx.sortDesc;

      if (sameColumn && !ctx.sortDesc) {
        this.subFilter.sortBy = "";
        this.subFilter.sortDesc = false;
        this.subFilter.SortColumnId = 0;
        this.subFilter.SortType = true;
      } else {
        this.subFilter.sortBy = ctx.sortBy;
        this.subFilter.sortDesc = ctx.sortDesc;

        const sortColumnMap = {
          branch_group: 1,
          branch_name: 2,
          stock_type_name: 3,
          quantity: 4,
          price: 4,
        };

        this.subFilter.SortColumnId = sortColumnMap[ctx.sortBy] || 0;
        this.subFilter.SortType = ctx.sortDesc;
      }

      if (!this.is_serial) {
        this.getSubItem();
      } else {
        this.getSubItemSerial();
      }
    },
  },
};
</script>
